class PdpTab extends HTMLElement {
  constructor() {
    super();

    this.pdpTabsSection = this.closest('section');
    this.button = this.querySelector('button');
    this.sectionToScrollTo = getNthSibling(this.pdpTabsSection, this.dataset.index);

    const sectionHeight = this.pdpTabsSection.offsetHeight;
    const bottomRootMargin = `${window.visualViewport.height - sectionHeight - 1}`;

    // For 1000px screen height and 70px section height
    // rootMargin: '-71px 0px -929px 0px'
    // Root margin gap must be 0px for it to not show 2 sections active in FF and Safari
    const observerOptions = {
      threshold: 0,
      rootMargin: `-${sectionHeight + 1}px 0px -${bottomRootMargin}px 0px`,
    };

    const observer = new IntersectionObserver(this.observerCallback, observerOptions);
    observer.observe(this.sectionToScrollTo);

    this.sectionToScrollTo.style.scrollMarginTop = `${sectionHeight}px`;

    this.button.addEventListener('click', () => {
      this.sectionToScrollTo.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    });
  }

  observerCallback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.button.classList.add('pdp-tabs__button--active');
      } else {
        this.button.classList.remove('pdp-tabs__button--active');
      }
    });
  };
}

function getNthSibling(element, n) {
  let sibling = element;

  for (let i = 0; i <= n; i++) {
    sibling = sibling?.nextElementSibling;
    if (!sibling) return null; // Stop if there are no more siblings
  }

  return sibling;
}

customElements.define('pdp-tab', PdpTab);
